import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';

export default function Dashboard() {
  return (
    <div className="p-6 pb-20 bg-background min-h-screen font-sans">
      <h1 className="text-3xl font-semibold mb-8 text-secondary font-sans tracking-tight">Admin Dashboard</h1>
      <nav className="space-y-4">
        <Link 
          to="/admin/services" 
          className="block btn-primary mb-2"
        >
          Manage Services
        </Link>
        <Link 
          to="/admin/outsource-roles" 
          className="block btn-primary mb-2"
        >
          Manage Outsource Roles
        </Link>
        {/* Service Prices moved to Artist panel */}
        <Link 
          to="/admin/users" 
          className="block btn-secondary mb-2"
        >
          Manage Users
        </Link>
      </nav>
      <Footer />
    </div>
  );
}